module.exports = angular.module('msi.payments.add', [
  'ui.router',
  require('../payment.service')
]).name;

angular.module(module.exports)
  .config(require('./state'));
